import { render, staticRenderFns } from "./Variance.vue?vue&type=template&id=06c9e6de"
import script from "./Variance.vue?vue&type=script&lang=js"
export * from "./Variance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports